import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../../Helpers/API";
import { Button, Modal, TextField, Grid } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import DownloadIcon from "@mui/icons-material/Download";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const InformacionCreditoModal = ({
  open,
  onClose,
  folio,
  documento,
}) => {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [data, setData] = useState([]);

  const onImprimirPedido = (iddocumento, prmfolio) => {
    if (folio === "SC28092024008") {
      Swal.fire(
        "GESTION DE COBRANZA",
        "Se detecto que la operación seleccionada, se facturo antes del lanzamiento de Humaya Digital, motivo por el cual no encontrara un pedido o pagare para esta operación, si requiere informacion adicional tendra que solicitarla al area de crédito.",
        "info"
      );
      return;
    }
    if (folio === "0000000000JDF") {
      Swal.fire(
        "GESTION DE COBRANZA",
        "La operación corresponde a un saldo por diferencia de contrato. <br />Por este motivo, la fecha de vencimiento será igual a la fecha de la factura, ya que no existe una solicitud de crédito registrada.<br />A partir de la generación de este registro, se comenzarán a generar intereses al cliente.",
        "info"
      );
      return;
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerPedidoFacturado?folio=${prmfolio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (
          result.length !== undefined &&
          result.length !== null &&
          result.length > 0
        ) {
          result.forEach((element) => {
            const linkSource =
              "data:application/pdf;base64," + element.documento;
            const downloadLink = document.createElement("a");
            const fileName = `${element.nombredocumento}.${element.extension}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          const linkSource = result.comentarios;
          const downloadLink = document.createElement("a");
          const fileName = `${result.documento}.${result.extension}`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDOS FACTURADOS", error.mensaje, "error");
      });
  };
  useEffect(() => {
    if (folio === undefined || folio === null || folio.length !== 13) return;

    if (folio === "SC28092024008") {
      Swal.fire(
        "GESTION DE COBRANZA",
        "Se detecto que la operación seleccionada, se facturo antes del lanzamiento de Humaya Digital, motivo por el cual no encontrara un pedido o pagare para esta operación, si requiere informacion adicional tendra que solicitarla al area de crédito.",
        "info"
      );
      onClose();
      return;
    }
    if (folio === "0000000000JDF") {
      Swal.fire(
        "GESTION DE COBRANZA",
        "La operación corresponde a un saldo por diferencia de contrato. <br />Por este motivo, la fecha de vencimiento será igual a la fecha de la factura, ya que no existe una solicitud de crédito registrada.<br />A partir de la generación de este registro, se comenzarán a generar intereses al cliente.",
        "info"
      );
      onClose();
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ObtenerConveniosClienteGestionar/ObtenerInfoCredito?folio=${folio}&documento=${documento}`
      )
      .then((result) => {
        setData(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        Swal.fire("GESTION DE COBRANZA", JSON.stringify(error), "error");
        setLoader({ ...loader, mostrar: false });
      });
  }, [folio]);
  return (
    <>
      <LoaderScreen loader={loader} />
      <Modal open={open} onClose={onClose}>
        <div className="modal-content">
          {open && data && (
            <PlantillaScreen
              titulo={`INFORMACION DE LA FACTURA ${folio}`}
              className={"asc-modal-pedidos-facturados"}
            >
              <div className="modal-content-wrapper">
                <div className="form-container">
                  <Grid container spacing={1}>
                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextField
                          label="Folio de la Solicitud"
                          value={data.folio || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextField
                          label="Responsable de Cobranza"
                          value={capitalizePalabras(data.razon_social)}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid container item spacing={1}>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Asesor de Venta"
                            value={data.asesor_ventas || "-"}
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Sucursal"
                            value={capitalizePalabras(data.sucursal) || "-"}
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Celular"
                            value={capitalizePalabras(data.celular) || "-"}
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Segunda fila: ID EQUIP, Serie Fiscal, Folio Fiscal, Documento Factura, Documento Pagaré */}
                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="ID EQUIP"
                          value={data.idequip || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Serie Fiscal"
                          value={data.serie_fiscal || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Folio Fiscal"
                          value={data.folio_fiscal || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Documento de la Factura"
                          value={data.documento_factura || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Documento del Pagaré"
                          value={data.documento_pagare || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Tasa Anual"
                          value={data.tasa_anual + " %" || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Días de Financiamiento"
                          value={data.dias_financiamiento || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Importe a Financiar"
                          value={FormatMoney(data.importe_financiar, 0) || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Interés Pactado"
                          value={FormatMoney(data.interes_pactado, 0) || "0"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Total a Pagar"
                          value={FormatMoney(data.total_pagar, 0) || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
              <div className="analisis-as-screen-footer">
                <div className="analisis-as-screen-x" onClick={onClose}>
                  X
                </div>
                <div className="button-container">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(1, folio)}
                  >
                    <DownloadIcon /> Descargar el Pedido
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(2, folio)}
                  >
                    <DownloadIcon />
                    Descargar el Pagaré
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(3, folio)}
                  >
                    <DownloadIcon />
                    Descargar la Factura
                  </Button>
                </div>
              </div>
            </PlantillaScreen>
          )}
        </div>
      </Modal>
    </>
  );
};
